import { ReactElement } from "react";

export enum Status {
  Available,
  InUse,
  QA,
  Defect,
}

export enum ProductTypesEnum {
  BackHub = "Back Hub",
  BackVest = "Back Vest",
  ElbowHub = "Elbow Hub",
  ElbowSleeve = "Elbow Sleeve",
}

export enum ProductSide {
  Right,
  Left,
}

export type ProductTypesObj = {
  productTypeId: number;
  name: ProductTypesEnum;
};

export interface InventoryData {
  productId: number;
  productType: ProductTypesObj;
  size: number;
  side: ProductSide;
  status: Status;
  location: string | null;
  note: string | null;
  plan: PlanTypes | null;
  serial: string;
  createdAt: Date;
  batchnumber: string;
  histories: HistoryData[];
  actions: ReactElement;
  isSelected: boolean;
}

export interface HistoryData {
  historyId: number;
  changedAt: Date;
  changedBy: string;
  fieldName: string;
  oldValue: string;
  newValue: string;
}

export type UpdatedFieldsData = {
  fieldname: string | null;
  oldvalue: string | null;
  newvalue: string | null;
};

export type Product = {
  serial: string;
  status?: Status | undefined;
  location?: string | null | undefined;
  note?: string | null | undefined;
};

export type Filters = {
  productType: string[];
  size: number[];
  side: string[];
  status: string[];
  location: string[];
  note: string[];
  plan: string[];
  serial: string[];
  batchnumber: string[];
};

export type PlanTypes = {
  inventoryPlanId?: number;
  companyName?: string;
  startDate: Date;
  endDate: Date;
  notificationDate: Date;
  plannedProducts: InventoryPlannedProducts[];
  allocatedProducts: InventoryData[];
};

export type InventoryPlannedProducts = {
  productType: ProductTypesObj;
  quantity: number;
};
